import { useMotionValue } from "motion/react";
import { FC, useEffect } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FloatingMenuStyled, useFloatMenu } from "@ryde/controls";
import {
  coursesCalendarSelectedSlotsCountSelector,
  ICoursesCalendarSlotDto,
  useIsMobile,
} from "@ryde/shared";

import { CoursesFloatingMenuCalendarInner } from "./courses.floating-menu.calendar.inner";

interface ICoursesFloatingMenuCalendar {
  createSlotRide: (slot: ICoursesCalendarSlotDto) => Promise<number>;
  onAfterProduce: () => void;
}

export const CoursesFloatingMenuCalendar: FC<ICoursesFloatingMenuCalendar> = ({
  createSlotRide,
  onAfterProduce,
}) => {
  const { isMobile } = useIsMobile();
  const selectedSlotsCount = useRecoilValue(
    coursesCalendarSelectedSlotsCountSelector,
  );
  const isOpened = Boolean(selectedSlotsCount);

  const {
    isInitFinished,
    leftX,
    bottomY,
    setLeftX,
    setBottomY,
    floatingMenuRef,
    setIsAllowedInitCentering,
  } = useFloatMenu({ page: "coursesCalendar", isOpened });
  const left = useMotionValue(leftX);
  const bottom = useMotionValue(bottomY);

  const onDragEndHandler = useEvent((): void => {
    setLeftX(left.get());
    setBottomY(bottom.get());
  });

  const onRender = useEvent(() => {
    setIsAllowedInitCentering(true);
  });

  useEffect(() => {
    if (!isOpened) {
      return;
    }
    left.set(leftX);
  }, [isOpened, left, leftX]);

  return (
    isOpened && (
      <FloatingMenuStyled
        ref={floatingMenuRef}
        drag
        dragElastic={0}
        dragMomentum={false}
        onDragEnd={onDragEndHandler}
        style={{
          x: left,
          bottom,
          opacity: !isInitFinished ? 0 : "initial",
        }}
      >
        {!isMobile && <SVG_MUI.GripVertical3SVG className="pointer grip" />}
        <CoursesFloatingMenuCalendarInner
          createSlotRide={createSlotRide}
          onAfterProduce={onAfterProduce}
          onRender={onRender}
        />
      </FloatingMenuStyled>
    )
  );
};
